import React, { Component } from "react";
import ListMember from "./List_member";

class MemberP2KB extends Component {
    render() {
        return (
            <ListMember />
        );
    }
}

export default MemberP2KB;
